import {
  ImageCtaCardSection,
  ImageWithTextSection,
  FAQSection,
  AboutUsHowItWorksSection,
  AboutUsWhatWeOfferSection
} from "@/design-system/Organisms";
import { aboutUsFaqDataConfig } from "@/design-system/Organisms/FAQSection/faq.config";
import { aboutUsImageCtaCardConfig } from "@/design-system/Organisms/ImageCtaCardSection/imageCtaCard.config";
import { aboutUsImageWithTextConfig } from "@/design-system/Organisms/ImageWithTextSection/imageWithText.config";
import { aboutUsOffersDataConfig } from "@/design-system/Organisms/AboutUsWhatWeOfferSection/offers.config";

export const AboutUsTemplate = () => {
  return (
    <>
      <ImageWithTextSection  {...aboutUsImageWithTextConfig} />
      <AboutUsHowItWorksSection />
      <AboutUsWhatWeOfferSection {...aboutUsOffersDataConfig} />
      <FAQSection {...aboutUsFaqDataConfig} />
      <ImageCtaCardSection {...aboutUsImageCtaCardConfig} />
    </>
  );
};


export default AboutUsTemplate;
